import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';
import { getPopupDispatchers, PopupContext } from '@app/dev/contexts/popup';

import { POPUPS } from '@common/constants/popups';
import NumericInput from '@common/components/numericInput';
import './styles.scss'
import { askForTerminalUsageConfirmationIfRequired } from '@app/dev/helpers/terminalUsageConfirmation';

let waitingDefer = null;

const StaffLoginPopup = () => {
  const t = useTranslation();
  const [errorMsg, setErrorMsg] = useState('');
  const [password, setPassword] = useState('');
  const [{ closePopup }] = useContext(PopupContext);

  useEffect(
    () => () => {
      waitingDefer?.resolve(false);
      waitingDefer = null;
    },
    [],
  );

  const onPasswordChange = (value) => {
    setPassword(value);

    if (value.length !== Config.main.staffPassword.length) return;

    if (value === Config.main.staffPassword) {
      waitingDefer?.resolve(true);
      closePopup();
    } else setErrorMsg('Wrong Password');
  };

  const cancel = () => {
    closePopup();
    askForTerminalUsageConfirmationIfRequired();
  };

  const submit = (e) => {
    e.preventDefault();
    if (password === Config.main.staffPassword) {
      waitingDefer?.resolve(true);
      closePopup();
    } else setErrorMsg('Wrong Password');
  };

  return (
    <div onClick={submit}>
      <div className="popup-content popup-small">
        <div className="mini-logo-container" />
        <div className="popup-main-content">
          <div className="input-wrapper">
            <div className="input-row">
              <NumericInput
                setFocus
                className="numeric-input staff-password-input"
                placeholder={t('Password')}
                value={password}
                onChange={onPasswordChange}
              />
            </div>
          </div>
          {errorMsg && (
            <div className="login-error">
              <span>{t(errorMsg)}</span>
            </div>
          )}
        </div>
        <div className="popup-actions">
          <button
            type="button"
            onClick={cancel}
            className="popup-cancel-button"
          >
            {t('Cancel')}
          </button>

          <button
            type="button"
            className="popup-confirm-button"
            disabled={!password}
          >
            {t('Login')}
          </button>
        </div>
      </div>
    </div>
  );
};

export const checkForStaffPass = () => new Promise((resolve, reject) => {
  if (!Config.main.staffPassword) resolve(true);
  else {
    const { openPopup } = getPopupDispatchers();
    waitingDefer = { resolve, reject };
    openPopup(POPUPS.STAFF_LOGIN);
  }
});

export default connect()(StaffLoginPopup);
